import { siteConfig } from "@latam-energy/content";

type EventName =
  | "quotation_form_submit"
  | "contact_form_submit"
  | "whatsapp_click"
  | "phone_click"
  | "email_click"
  | "download_click"
  | "product_quotation_click"
  | "newsletter_subscription"
  | "main_cta_click";

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export function trackEvent(name: EventName, params: Record<string, string> = {}) {
  if (typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", name, params);
}

export function AnalyticsScripts() {
  const gaId = siteConfig.analytics.gaId;
  const gtmId = siteConfig.analytics.gtmId;
  return (
    <>
      {gtmId ? <script id="gtm">{`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${gtmId}');`}</script> : null}
      {gaId ? (
        <>
          <script async src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`} />
          <script id="ga4">{`window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${gaId}',{anonymize_ip:true});`}</script>
        </>
      ) : null}
    </>
  );
}
